<p-button 
    icon="far fa-copy"
    [rounded]="true"
    [text]="true"
    [pTooltip]="l('::Copy')"
    tooltipPosition="right"
    (onClick)="onClick()" />